(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pourquoi-choisir-set"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initWhy(root) {
      if (root.dataset.whyInit === 'true') return;
      root.dataset.whyInit = 'true';

      // Pas d'animation dans l'éditeur de thème : les blocs restent toujours visibles.
      if (!root.hasAttribute('data-animate')) return;
      if (window.Shopify && window.Shopify.designMode) return;
      if (!('IntersectionObserver' in window)) return;

      var items = root.querySelectorAll('.yoshi-why__item');
      if (!items.length) return;

      root.classList.add('is-animated');

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.2 });

      for (var i = 0; i < items.length; i++) {
        observer.observe(items[i]);
      }
    }

    function boot() {
      var nodes = document.querySelectorAll('.yoshi-why');
      for (var i = 0; i < nodes.length; i++) {
        initWhy(nodes[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yoshida-collection-feature"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initFeature(el) {
    var inner  = el.querySelector('.yoshi-cf__text-inner');
    var outer  = el.querySelector('.yoshi-cf__text-outer');
    var btn    = el.querySelector('.yoshi-cf__toggle');
    var label  = el.querySelector('.yoshi-cf__toggle-label');

    if (!inner || !btn) return;

    // Si le texte est déjà court : on ouvre et on cache le bouton
    if (inner.scrollHeight <= 140) {
      inner.classList.add('is-open');
      outer.classList.add('is-open');
      btn.hidden = true;
      return;
    }

    btn.hidden = false;

    btn.addEventListener('click', function () {
      var opening = !inner.classList.contains('is-open');
      inner.classList.toggle('is-open', opening);
      outer.classList.toggle('is-open', opening);
      btn.classList.toggle('is-open', opening);
      btn.setAttribute('aria-expanded', String(opening));
      label.textContent = opening ? 'Réduire' : 'Lire la suite';
    });
  }

  function boot() {
    document.querySelectorAll('.yoshi-cf').forEach(initFeature);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yoshida-collection-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initHero(el) {
    var cta = el.querySelector('.yoshi-hero__cta');
    if (!cta) return;

    cta.addEventListener('click', function () {
      var sectionWrapper = el.closest('.shopify-section');
      var target = sectionWrapper ? sectionWrapper.nextElementSibling : null;
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  function boot() {
    document.querySelectorAll('.yoshi-hero').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
